<template>
  <div class="main_Container">
    <section class="p-4 detailsView">
      <div class="container-fluid">
        <div v-show="this.isloading" class="data__loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="card" v-show="!this.isloading">
          <div class="card-header">
            <h3 class="card-header-title">تفاصيل الدرس</h3>
          </div>
          <div class="card-body">
            <form>
              <div class="row">
                <!---------------->
                <!-- Right Side -->
                <div class="col-md-7 col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for="lessonTitle">العنوان</label>
                        <input
                          type="text"
                          class="form-control mt-2"
                          id="lessonTitle"
                          :value="this.lesson.title"
                          readonly
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="adding">
                        <div class="adding__head">
                          <label>محتوى للدرس</label>
                        </div>

                        <div class="adding__content">
                          <!-- Show All Files -->
                          <div
                            class="table-responsive"
                            v-if="this.lesson.contents.length > 0"
                          >
                            <Transition name="scale" mode="out-in">
                              <table
                                class="table styled-table sub_table mt-2 subject-table table-striped"
                              >
                                <thead>
                                  <tr>
                                    <th class="fit" scope="col">الرقم</th>
                                    <th scope="col">العنوان</th>
                                    <th style="width: 20%" scope="col">
                                      نوع الملف
                                    </th>
                                    <th class="fit" scope="col">التحكم</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(file, index) in this.lesson
                                      .contents"
                                    :key="index"
                                  >
                                    <th class="text-center" scope="row">
                                      {{ index + 1 }}
                                    </th>

                                    <td>{{ file.title }}</td>
                                    <td>{{ filterItems(file.type) }}</td>
                                    <td>
                                      <div class="actions-group">
                                        <div v-if="file.type === 3">
                                          <router-link
                                            :to="{
                                              name: 'exam_students',
                                              params: { id: file.id },
                                            }"
                                            class="btn students icon"
                                          >
                                            <img
                                              class="img-invert"
                                              src="@/assets/login-icon/users-solid.svg"
                                              alt="Students"
                                            />
                                          </router-link>
                                        </div>
                                        <div>
                                          <button
                                            type="button"
                                            class="btn view icon"
                                            data-bs-toggle="modal"
                                            data-bs-target="#fileDetails"
                                            @click="getFileDetails(file)"
                                          >
                                            <i class="fas fa-folder"></i>
                                          </button>
                                        </div>
                                        <div>
                                          <router-link
                                            :to="`/admin/lessons/view_lesson/${$route.params.index}/${file.id}`"
                                            class="btn btn-success icon"
                                            v-if="file.type === 2"
                                          >
                                            <i class="fas fa-eye"></i>
                                          </router-link>
                                        </div>
                                      </div>
                                      <!-- Start View Category Modal -->
                                      <div
                                        class="modal fade"
                                        id="fileDetails"
                                        tabindex="-1"
                                        aria-labelledby="fileDetailsLabel"
                                        aria-hidden="true"
                                      >
                                        <div
                                          class="modal-dialog modal-dialog-centered"
                                        >
                                          <div class="modal-content">
                                            <div class="modal-body">
                                              <div class="text-start">
                                                <button
                                                  type="button"
                                                  class="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                              <!-- Question View -->

                                              <div class="form-group">
                                                <label for="fileName"
                                                  >العنوان</label
                                                >
                                                <input
                                                  type="text"
                                                  class="form-control"
                                                  id="fileName"
                                                  placeholder="اسم الملف"
                                                  :value="this.file.title"
                                                  readonly
                                                />
                                              </div>
                                              <!-- File -->
                                              <div v-if="this.file.type == 1">
                                                <div
                                                  v-if="
                                                    this.file.file_type == 1
                                                  "
                                                >
                                                  <img
                                                    class="img-fluid"
                                                    :src="this.file.url"
                                                    alt="fileImage"
                                                  />
                                                </div>
                                                <div
                                                  v-else-if="
                                                    this.file.file_type == 2
                                                  "
                                                >
                                                  <div class="file__container">
                                                    <a :href="this.file.url">
                                                      لرؤيت الملف
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <!-- Video -->
                                              <div v-if="this.file.type == 2">
                                                <div class="video__container">
                                                  <!-- Price -->
                                                  <div class="form-group">
                                                    <label for="videoPrice"
                                                      >السعر</label
                                                    >
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      id="videoPrice"
                                                      placeholder="سعر الفيديو"
                                                      :value="this.file.price"
                                                      readonly
                                                    />
                                                  </div>
                                                  <!-- Description -->
                                                  <div class="form-group">
                                                    <label
                                                      for="videoDescription"
                                                      >وصف فيديو</label
                                                    >
                                                    <textarea
                                                      id="videoDescription"
                                                      v-if="
                                                        this.file.description
                                                      "
                                                      :value="
                                                        this.file.description
                                                      "
                                                      class="form-control"
                                                      readonly
                                                      cols="30"
                                                      rows="5"
                                                    ></textarea>
                                                    <span
                                                      v-else
                                                      class="text-muted"
                                                    >
                                                      لا يوجد وصف
                                                    </span>
                                                  </div>
                                                  <!-- Additional URL -->
                                                  <div class="form-group">
                                                    <label for="videoUrl"
                                                      >رابط الفيديو</label
                                                    >
                                                    <div
                                                      class="file__container mt-2"
                                                      v-if="
                                                        this.file.additional_url
                                                      "
                                                    >
                                                      <a
                                                        :href="
                                                          this.file
                                                            .additional_url
                                                        "
                                                      >
                                                        لرؤيت الفيديو
                                                      </a>
                                                    </div>
                                                    <div
                                                      class="file__container mt-2"
                                                      v-else
                                                    >
                                                      <span
                                                        >لا يوجد رابط
                                                        للفيديو</span
                                                      >
                                                    </div>
                                                  </div>
                                                  <!-- Video -->
                                                  <div class="form-group">
                                                    <label for="videoShow"
                                                      >الفيديو</label
                                                    >
                                                    <div
                                                      class="embedVideo mt-2"
                                                      v-html="this.file.embed"
                                                    ></div>
                                                  </div>
                                                  <!-- Video -->
                                                  <div class="form-group">
                                                    <label for="videoDuration"
                                                      >مدة الفيديو</label
                                                    >
                                                    <input
                                                      type="number"
                                                      class="form-control"
                                                      id="videoDuration"
                                                      placeholder="مدة الفيديو"
                                                      :value="
                                                        this.file.duration
                                                      "
                                                      readonly
                                                    />
                                                  </div>
                                                  <!-- Thum -->
                                                  <div class="form-group">
                                                    <label for="videoThum"
                                                      >صورة الفيديو</label
                                                    >
                                                    <div
                                                      v-if="
                                                        this.file.thumbnail_url
                                                      "
                                                    >
                                                      <img
                                                        class="img-fluid mt-2"
                                                        :src="
                                                          this.file
                                                            .thumbnail_url
                                                        "
                                                        alt="videoThum"
                                                      />
                                                    </div>

                                                    <div
                                                      class="file__container mt-2"
                                                      v-else
                                                    >
                                                      <span
                                                        >لا يوجد صورة
                                                        للفيديو</span
                                                      >
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <!-- Exam -->
                                              <div
                                                v-else-if="this.file.type == 3"
                                              >
                                                <div class="row">
                                                  <div class="col-6">
                                                    <div class="form-group">
                                                      <label for="ExamDuration"
                                                        >مدة الاختبار</label
                                                      >
                                                      <input
                                                        type="number"
                                                        class="form-control mt-2"
                                                        id="ExamDuration"
                                                        placeholder="مدة الاختبار بالدقائق"
                                                        :value="
                                                          this.file.duration
                                                        "
                                                        readonly
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-6">
                                                    <div class="form-group">
                                                      <label for="ExamDegree"
                                                        >مجموع الاختبار</label
                                                      >

                                                      <input
                                                        type="number"
                                                        class="form-control mt-2"
                                                        id="ExamDuration"
                                                        placeholder="مجموع الاختبار"
                                                        :value="
                                                          this.file.degree
                                                        "
                                                        readonly
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-6">
                                                    <div class="form-group">
                                                      <label for="ExamStartDate"
                                                        >بداية الاختبار</label
                                                      >

                                                      <input
                                                        type="datetime-local"
                                                        class="form-control mt-2"
                                                        id="ExamDuration"
                                                        placeholder="بداية الاختبار"
                                                        :value="
                                                          this.file.start_date
                                                        "
                                                        readonly
                                                      />
                                                    </div>
                                                  </div>
                                                  <div class="col-6">
                                                    <div class="form-group">
                                                      <label for="ExamEndDate"
                                                        >نهاية الاختبار</label
                                                      >

                                                      <input
                                                        type="datetime-local"
                                                        class="form-control mt-2"
                                                        id="ExamEndDate"
                                                        placeholder="نهاية الاختبار"
                                                        :value="
                                                          this.file.end_date
                                                        "
                                                        readonly
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="questions">
                                                  <div
                                                    v-for="(
                                                      question, index
                                                    ) in this.file.questions"
                                                    :key="index"
                                                  >
                                                    <div class="row">
                                                      <!-- Question -->
                                                      <div class="col-12">
                                                        <div class="form-group">
                                                          <label
                                                            class="mb-2"
                                                            for="ExamDuration"
                                                            >{{ index + 1 }}-
                                                            السؤال</label
                                                          >
                                                          <img
                                                            :src="question.url"
                                                            class="w-100"
                                                            v-if="
                                                              question.questionType ==
                                                              1
                                                            "
                                                          />
                                                          <div
                                                            class="hasQuestion"
                                                            v-if="
                                                              question.questionType ==
                                                              3
                                                            "
                                                            v-html="
                                                              question.title
                                                            "
                                                          ></div>
                                                        </div>
                                                      </div>
                                                      <!-- Answers -->
                                                      <div
                                                        class="col-6"
                                                        v-for="(
                                                          answer, index
                                                        ) in question.answers"
                                                        :key="index"
                                                      >
                                                        <div class="form-group">
                                                          <input
                                                            type="text"
                                                            :class="[
                                                              {
                                                                rightAnswer:
                                                                  question.isRight ==
                                                                  index,
                                                              },
                                                              'form-control mt-2',
                                                            ]"
                                                            placeholder="الاجابة"
                                                            :value="
                                                              question.answers[
                                                                index
                                                              ].title
                                                            "
                                                            readonly
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- Question View -->
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Transition>
                          </div>

                          <div class="noDataFound" v-else>
                            <span>لا يوجد محتوى</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---------------->
                <!---------------->
                <!-- Left Side -->
                <div class="col-md-5">
                  <div class="form-group">
                    <label for="lessonPrice">السعر</label>
                    <input
                      type="number"
                      class="form-control mt-2"
                      id="lessonPrice"
                      :value="this.lesson.price"
                      placeholder="السعر"
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>صورة الدرس</label>
                    <div v-if="this.lesson.icon">
                      <img
                        :src="this.lesson.icon"
                        class="img-fluid mt-2"
                        alt="lesson"
                      />
                    </div>

                    <div class="img__container mt-2" v-else>
                      <span class="">لا توجد صورة للدرس</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="lessonStatus">حالة الدرس</label>
                        <select
                          class="form-select form-control mt-2"
                          aria-label="Default select "
                          v-model="lesson.status"
                          disabled
                        >
                          <option selected disabled value="">
                            اختار حالة الدرس
                          </option>
                          <option :value="0">حفظ داخل مسودة</option>
                          <option :value="1">نشر</option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="col-lg-6"
                      v-if="this.lesson.fullCategoriesInfo != null"
                    >
                      <div class="form-group">
                        <label>التصنيف الحالى</label>

                        <div class="categories mt-2">
                          <ul class="pe-2">
                            <li
                              v-for="category in this.lesson.fullCategoriesInfo"
                              :key="category.category_id"
                            >
                              - {{ category.title }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!---------------->
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      isloading: true,
      lessonIndex: this.$route.params.index,
      lessons: [],
      lesson: {},
      file: {},
    };
  },
  methods: {
    ...mapActions("lessonsModule", ["getLessonById"]),
    filterItems(type) {
      switch (type) {
        case 1:
          this.files = this.lesson.contents;
          return "ملف";
        case 2:
          this.video = this.lesson.contents;
          return "فيديو";
        case 3:
          this.exam = this.lesson.contents;
          return "اختبار";
      }
    },
    getFileDetails(file) {
      this.file = file;
      console.log(this.file);
    },
  },
  async created() {
    this.lesson = this.getLessons[this.lessonIndex];
    console.log("lesson", this.lesson);
  },
  computed: {
    ...mapGetters("lessonsModule", ["isLoading", "getLessons"]),
  },
  mounted() {
    this.isloading = this.isLoading;
    this.lessons = this.getLessons;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
    getLessons() {
      this.lessons = this.getLessons;
    },
  },
};
</script>

<style lang="scss">
.rightAnswer {
  // The correct answer reads as a success state, not just a grey row.
  background-color: var(--success-bg) !important;
  color: var(--success-text) !important;
}
.hasQuestion {
  border: 1px solid var(--border);
  border-radius: 7px;
  padding: 5px 10px;
  height: 120px;
  overflow: auto;
}
.file__container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border-radius: 7px;
  border: 1px solid var(--border);
  a {
    color: var(--text-primary);
    font-size: 1rem;
    font-weight: 700;
  }
}
.embedVideo {
  overflow: hidden;
}
.noDataFound {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  border: 1px solid var(--border);
  border-radius: 7px;
  margin-top: 7px;
}
.actions-group {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>
